import { Component, Input } from '@angular/core';

import { WalletConnectService } from '../../services/wallet-connect.service';
import { convertNum } from '../../shared/constants/app-enums';
import { PopupService } from '../../services/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReferComponent } from '../../modals/refer/refer.component';
import { AnalyticsService } from '../../services/analytics.service';
import { ICounter } from '../../shared/interfaces/common.interface';

@Component({
  selector: 'app-round-user-details',
  templateUrl: './round-user-details.component.html',
  styleUrl: './round-user-details.component.scss',
})

// This component is used to show the Round timer, User purchased details, Round title etc
export class RoundAndUserDetails {
  // Values to be taken from widget component
  @Input() liveCounter: ICounter = {
    _days: 0,
    _hours: 0,
    _minutes: 0,
    _seconds: 0,
    _diff: 0,
  };
  @Input() raisedInfo: {
    usdRaised: number;
    raisedPercent: string;
    userStaked: number;
    userEthClaimable: number;
    userClaimable: number;
    maxAmount: number;
  } = {
    raisedPercent: '',
    usdRaised: 0,
    userClaimable: 0,
    userEthClaimable: 0,
    userStaked: 0,
    maxAmount: 0,
  };
  // Values to be taken from widget component
  tokenName = environment.tokenName;
  modalRef!: BsModalRef<ReferComponent>;

  constructor(
    private WalletConnectService: WalletConnectService,
    private popupService: PopupService,
    private translate: TranslateService,
    private modalService: BsModalService,
    private analyticService: AnalyticsService,
  ) {}

  get walletAddress() {
    return this.WalletConnectService.walletAddress;
  }

  convertNum(amount: number) {
    return convertNum(amount);
  }

  yourPurchasedInfo() {
    this.popupService.messagePopup({
      icon: 'info',
      desc: this.translate.instant('popup.your_purchased_popup_info'),
      confirmBtnTxt: this.translate.instant('misc.ok'),
    });
  }

  stakeInfo() {
    this.popupService.messagePopup({
      icon: 'info',
      desc: this.translate.instant('staking.stake_popup_info'),
      confirmBtnTxt: this.translate.instant('misc.ok'),
    });
  }

  get referUrl() {
    return this.analyticService.referUrl;
  }

  referAndEarn(): void {
    this.modalRef = this.modalService.show(ReferComponent, {
      class: 'modal-min modal-dialog-centered',
      backdrop: 'static',
      initialState: { url: this.referUrl },
    });
  }
}
